export default {
    apiKey: 'AIzaSyDjOMeuqF54U0wbA-Lg7pyUCqNKUl9HhBQ',
    authDomain: 'liscio-quizme.firebaseapp.com',
    databaseURL: 'https://liscio-quizme.firebaseio.com',
    projectId: 'liscio-quizme',
    storageBucket: 'liscio-quizme.appspot.com',
    messagingSenderId: '970486982083',
    appId: '1:970486982083:web:6a132857954ffa86',
    measurementId: '204420438',
};
